import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mediaComponent from './media.component';

let mediaModule = angular.module('app.containers.media', [
  uiRouter
])

.config(($stateProvider) => {
  "ngInject";
  $stateProvider
    .state('media', {
      url: '/media',
      template: '<media></media>'
    });
})

.component('media', mediaComponent);

export default mediaModule;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/media/media.js
 **/